import { TableCell } from '@mui/material';
import { formatBalanceUi, FRACTION_DIGITS } from '@utils/balance-helpers';

export default function TeamTxCardLimitCell({ row }) {
  return (
    <TableCell align="right">
      <p>
        {formatBalanceUi(row.transaction_limit, 'USD', FRACTION_DIGITS.INTEGER)}
      </p>
      <p className="secondary-text">
        {formatBalanceUi(
          row.monthly_card_spent_limit,
          'USD',
          FRACTION_DIGITS.INTEGER,
        )}
      </p>
    </TableCell>
  );
}
